const fallbackInitialPage = "/dashboard";

export function normalizeInitialPage(page: string | null | undefined): string {
  const normalizedPage = page?.trim();
  return !normalizedPage || normalizedPage === "/" ? fallbackInitialPage : normalizedPage;
}
